var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.72,
    height: 47.848,
    viewBox: "0 0 46.72 47.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#898e9a}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__np_office_1103564_000000",
    transform: "translate(-5.816 -4.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1072",
    d: "M32.316 22.75h20.059v1.586H32.316z",
    className: "prefix__cls-1",
    "data-name": "Trac\\xE9 1072",
    transform: "translate(-12.489 -8.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1073",
    d: "M32.316 13.75h20.059v1.586H32.316z",
    className: "prefix__cls-1",
    "data-name": "Trac\\xE9 1073",
    transform: "translate(-12.489 -4.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1074",
    d: "M67.379 39.363a5.245 5.245 0 1 0 5.244 5.246 5.252 5.252 0 0 0-5.244-5.246zm0 8.9a3.659 3.659 0 1 1 3.658-3.658 3.664 3.664 0 0 1-3.658 3.661z",
    className: "prefix__cls-1",
    "data-name": "Trac\\xE9 1074",
    transform: "translate(-26.542 -16.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_1075",
    d: "M44.676 48.064c.927-1.594 1.925-3.461 2.883-5.4 1.5-3.03 4.977-10.5 4.977-14.366a11.718 11.718 0 0 0-7.86-11.051V4.75H14.54v20.33a4.276 4.276 0 0 0-1.663-.347 4.69 4.69 0 0 0-4.554 4.806 5.045 5.045 0 0 0 .339 1.822A6.5 6.5 0 0 0 5.816 36.7a6.668 6.668 0 0 0 6.08 6.522V48.1H6.607v1.59h31.586c1.72 2.677 2.276 2.908 2.767 2.908s1.047-.231 2.732-2.908h7.047V48.1h-6.064zM16.126 6.336H43.09v10.479a11.672 11.672 0 0 0-9.38 2.212H19.817v1.586h12.208a11.718 11.718 0 0 0-1.983 3.172H19.817v1.586h9.69a11.691 11.691 0 0 0-.37 2.926c0 .076.01.165.012.246h-9.332v1.586h9.523a24.894 24.894 0 0 0 .86 3.171H19.827v1.586h10.936c.407 1.078.853 2.154 1.3 3.172H19.826V48.1h-3.7V6.336zM21.411 48.1v-8.456h7.4V48.1zm8.99 0v-8.456h2.375c.558 1.2 1.076 2.257 1.464 3.024.987 1.954 2.018 3.831 2.974 5.436zM7.4 36.7a4.957 4.957 0 0 1 2.66-4.335l.725-.388-.415-.71a3.414 3.414 0 0 1-.461-1.722 3.106 3.106 0 0 1 2.968-3.22 2.8 2.8 0 0 1 1.663.558v14.426a5.371 5.371 0 0 1-1.912.359A5.108 5.108 0 0 1 7.4 36.7zm6.08 6.5a7.429 7.429 0 0 0 1.057-.213v5.12h-1.055zm27.476 7.646C38.831 48.624 30.721 33.691 30.721 28.3a10.116 10.116 0 1 1 20.231 0c0 5.407-7.914 20.324-9.994 22.548z",
    className: "prefix__cls-1",
    "data-name": "Trac\\xE9 1075"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCenter);
export default __webpack_public_path__ + "static/media/picto-center.c923188c738262bf4a5dd6a66e026448.svg";
export { ForwardRef as ReactComponent };